module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_e-Akte.1fa1a875.svg";